import { render, staticRenderFns } from "./articles-grid.vue?vue&type=template&id=a2e73c3a&lang=html&"
import script from "./articles-grid.vue?vue&type=script&lang=js&"
export * from "./articles-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports